export const GET_SEARCH_RESULTS_REQUEST = 'GET_SEARCH_RESULTS_REQUEST';
export type GET_SEARCH_RESULTS_REQUEST = typeof GET_SEARCH_RESULTS_REQUEST;
export const GET_SEARCH_RESULTS_RESPONSE = 'GET_SEARCH_RESULTS_RESPONSE';
export type GET_SEARCH_RESULTS_RESPONSE = typeof GET_SEARCH_RESULTS_RESPONSE;
export const GET_SEARCH_RESULTS_ERROR = 'GET_SEARCH_RESULTS_ERROR';
export type GET_SEARCH_RESULTS_ERROR = typeof GET_SEARCH_RESULTS_ERROR;
